export const getStatusStyles = (status: { color?: string }) => ({
  container: {
    background: `linear-gradient(125deg, ${status?.color}88 20%, #ffffff88 85%)`,
  },
  iconWrapper: {
    background: `linear-gradient(100deg, ${status?.color} 100%, #ffffff 200%)`,
    opacity: 1,
  },
});
